import React from 'react';
import PropTypes from 'prop-types';

const Svg = ({ fill, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={{
      width,
    }}
    viewBox="0 0 16 16"
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      <g
        fillRule="nonzero"
      >
        <g>
          <g>
            <g
              transform="translate(-32 -493) translate(0 132) translate(16 240) translate(16 121)"
            >
              <circle
                cx="8"
                cy="8"
                r="4"
                fill="#F9ED32"
              />
              <path
                fill={fill}
                d="M6.985 2.398c.567-.53 1.463-.53 2.03 0l.662.615.918-.124c.752-.105 1.461.367 1.633 1.083l.017.08.157.859.808.411c.682.345.973 1.143.671 1.823l-.036.076-.397.78.396.777c.347.673.093 1.484-.559 1.86l-.074.04-.81.412-.156.857c-.13.735-.818 1.237-1.565 1.175l-.083-.01-.92-.125-.662.615c-.248.233-.571.371-.912.394L8 14c-.377 0-.74-.142-1.011-.396l-.664-.616-.97.13-.051.005-.103.004c-.71 0-1.321-.494-1.443-1.178l-.157-.859-.81-.411c-.683-.344-.974-1.143-.672-1.823l.036-.075L2.552 8l-.396-.778c-.346-.673-.093-1.482.559-1.86l.074-.04.81-.411.156-.857c.13-.735.819-1.238 1.565-1.175l.083.01.92.125zm1.4.674c-.212-.198-.558-.198-.77 0l-.705.656c-.178.164-.42.24-.66.207l-.973-.132c-.296-.041-.566.147-.614.415l-.169.924c-.043.244-.2.452-.42.563l-.868.441c-.254.129-.352.417-.229.656l.43.843c.115.224.115.487 0 .708l-.43.848c-.123.237-.026.525.23.654l.869.441c.22.112.377.32.42.56l.17.93c.043.237.266.418.535.418.026 0 .053-.002.08-.006l.969-.131c.241-.034.486.042.662.207l.706.655c.1.094.238.148.382.148.145 0 .283-.054.386-.15l.703-.653c.178-.166.422-.242.661-.208l.973.132c.296.041.566-.147.614-.415l.169-.925c.044-.243.2-.45.42-.562l.868-.442c.255-.128.352-.416.229-.655l-.43-.843c-.115-.224-.115-.487 0-.708l.43-.848c.123-.238.026-.525-.23-.654l-.866-.44c-.22-.112-.378-.32-.42-.562l-.17-.928c-.048-.266-.318-.454-.616-.412l-.97.131c-.24.033-.483-.043-.661-.208zm1.955 1.586c.178.126.222.372.097.55L6.21 11.245c-.06.086-.152.145-.255.163-.103.018-.21-.006-.294-.066-.086-.06-.145-.152-.163-.255-.018-.103.005-.209.066-.294L9.79 4.755c.125-.178.371-.221.55-.097zM9.5 8c.827.003 1.496.672 1.499 1.502-.003.826-.672 1.495-1.5 1.498-.829-.001-1.5-.672-1.5-1.5S8.671 8 9.501 8zM9.5 9l-.057.003c-.249.03-.442.24-.442.497 0 .276.224.5.498.5.277 0 .501-.225.502-.498C10 9.225 9.775 9 9.499 9zM6.502 5c.826.003 1.495.672 1.498 1.502C7.997 7.33 7.328 7.997 6.5 8 5.672 8 5.002 7.33 5 6.5l.003-.087C5.05 5.625 5.7 5.003 6.502 5zM6.5 6l-.057.004c-.249.03-.442.24-.443.496l.003.059c.03.248.241.44.495.441.277 0 .5-.225.502-.498 0-.277-.225-.501-.5-.502z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Svg.propTypes = {
  fill: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};

export default Svg;
